import React from "react";
import { Feed, Icon } from "semantic-ui-react";
import { calculateDateDifference, printDaysLeft } from "../../Helpers";
import "../../styles/list.scss";

const BCDashboardFeed = ({ ...props }) => {
  return (
    <Feed className="dashboard-feed">
      <Feed.Event>
        <Feed.Content>
          {props.data && props.data.map((item, i) => {
            if (item.action && item.action === "created") {
              return (
                <Feed.Summary key={"dashboard-feed-" + i} className="dashboard-feed-summary dashboard-feed-yellow">
                  Task Created for <span className="dashboard-link">{item.projectName}</span>
                  <Feed.Date>{printDaysLeft(calculateDateDifference(item.date))}</Feed.Date>
                  <div className="dashboard-feed-review">
                    <span>REVIEW</span>
                    <Icon className="dashboard-feed-icon" name='angle right' size="large" />
                  </div>
                </Feed.Summary>
              );
            }
            else if (item.action && item.action === "closed") {
              return (
                <Feed.Summary key={"dashboard-feed-" + i} className="dashboard-feed-summary dashboard-feed-green">
                  <span className="dashboard-link">{item.projectName}</span> has Closed!
                  <Feed.Date>{printDaysLeft(calculateDateDifference(item.date))}</Feed.Date>
                  <div className="dashboard-feed-review">
                    <span>REVIEW</span>
                    <Icon className="dashboard-feed-icon" name='angle right' size="large" />
                  </div>
                </Feed.Summary>
              );
            }
            else if (item.action && item.action === "upload") {
              return (
                <Feed.Summary key={"dashboard-feed-" + i} className="dashboard-feed-summary dashboard-feed-red">
                  <span className="dashboard-link">{item.owner}</span> uploaded <span className="dashboard-link">{item.documentType}</span> for <span className="dashboard-link">{item.projectName}</span>
                  <Feed.Date>{printDaysLeft(calculateDateDifference(item.date))}</Feed.Date>
                  <div className="dashboard-feed-review">
                    <span>REVIEW</span>
                    <Icon className="dashboard-feed-icon" name='angle right' size="large" />
                  </div>
                </Feed.Summary>
              );
            }
            else {
              return null;
            }
          })}
        </Feed.Content>
      </Feed.Event>
    </Feed>
  );
};

export default BCDashboardFeed;